import styled from 'styled-components';

export const FullPageSpinnerOuterContainerStyled = styled.main`
  position: fixed;
  background: rgba(255 255 255 / 80%);
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
`;
